// apps/web/src/components/ui/PageHeader.tsx
// Unified sub-page header: optional back chevron + title + optional right slot.
import { Link, useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useT } from "../../lib/i18n";

export function PageHeader({ back, title, right }: {
  /** A route, or "history" to return wherever the user actually came from
   *  (a page reachable from more than one place must use "history"). */
  back?: string;
  title: string;
  right?: ReactNode;
}) {
  const t = useT();
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-3">
      {back === "history" ? (
        <button onClick={() => navigate(-1)} aria-label={t("common.back")} className="text-fg-muted text-2xl leading-none -ml-1 press min-w-[44px] text-left">
          ‹
        </button>
      ) : back ? (
        <Link to={back} aria-label={t("common.back")} className="text-fg-muted text-2xl leading-none -ml-1 press">
          ‹
        </Link>
      ) : null}
      <h1 className="text-2xl font-semibold flex-1 truncate">{title}</h1>
      {right}
    </div>
  );
}
